import CateringCard from "../CateringCard/CateringCard";

import "./CateringGrid.css";

function CateringGrid({
  packages,
  onView,
  onEdit,
  onDelete,
}) {
  return (
    <div className="catering-grid">

      {packages.map((item) => (

        <CateringCard
          key={item._id}
          packageData={item}
          onView={onView}
          onEdit={onEdit}
          onDelete={onDelete}
        />

      ))}

    </div>
  );
}

export default CateringGrid;